import {SyntheticEvent} from 'react';
import {FormControlLabel, FormControlLabelProps, SxProps} from '@mui/material';
import {CustomCheckbox} from './checkbox';

interface NestedCheckboxProps extends Omit<FormControlLabelProps, 'control' | 'onChange'> {
  onChange: (selected: boolean) => void;
}

const formControlSx: SxProps = {
  paddingY: '6px',
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.175px',
    color: 'var(--dcm-gray)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

const NestedCheckbox = ({label, checked, onChange}: NestedCheckboxProps) => {
  const handleCheckboxChange = (_event: SyntheticEvent<Element, Event>, checked: boolean) => {
    onChange(checked);
  };

  return (
    <FormControlLabel
      control={<CustomCheckbox onChange={handleCheckboxChange} />}
      sx={formControlSx}
      label={label}
      checked={checked}
    />
  );
};

export default NestedCheckbox;
